<mat-nav-list class="sd_bar">
  <div class="logo-brand">
    <figure class="logo"><img src={{assetsConst.logo}} alt="logo" /></figure>
    <button (click)="toggleSidenav()" class="btnn btn_close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="side-scroll">
    @for (item of sideBar; track $index) {
      <div>
        @if (!item.isSubMenu) {
          @if (item.isView) {
            <mat-list-item [routerLink]="item.path" routerLinkActive="active" disableRipple>
              <figure class="sd_cn" matTooltip="{{item.label  | translate}}">
                <img src="{{item.img}}" alt="" />
              </figure>
              <div class="sidenav-item">
                <h5 class="lead">{{ item.label | translate }}</h5>
              </div>
            </mat-list-item>
          }
        }
  
        @if (item.isSubMenu) {
          <mat-accordion>
            <mat-expansion-panel class="drop_lst_nv">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-list-item disableRipple>
                    <figure class="sd_cn" mat-raised-button matTooltip="{{item.label | translate}}">
                      <img src="{{item.img}}" alt="" />
                    </figure>
      
                    <div class="sidenav-item">
                      <h5 class="lead">{{ item.label | translate }}</h5>
                    </div>
                  </mat-list-item>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <mat-list-item *ngFor="let sub of item.subMenuItems" [routerLink]="sub.path" disableRipple>
                <figure class="sd_cn" matTooltip="{{ item.label }}" matTooltip="{{item.label | translate}}">
                  <img src="{{sub.img}}" alt="images">
                </figure>
                <div class="sidenav-item">
                  <h5 class="lead">{{ sub.label | translate }}</h5>
                </div>
              </mat-list-item>
            </mat-expansion-panel>
          </mat-accordion>
        }
      </div>
    }
  </div>
</mat-nav-list>
